// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetCallLogsRequestModel from '../../model/get-call-logs-request-model';
import GetCallLogsRequestDTO from '../dto/get-call-logs-request-dto';

export default abstract class GetCallLogsRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetCallLogsRequestDTO>) {
    super();
    if (data) {
      this.correlationId = data.correlationId;
      this.from = data.from;
      this.to = data.to;
      this.searchCriteria = data.searchCriteria;
      this['paging.CurrentPage'] = data['paging.CurrentPage'];
      this['paging.PageSize'] = data['paging.PageSize'];
      this['paging.IncludeCount'] = data['paging.IncludeCount'];
      this['paging.NoPaging'] = data['paging.NoPaging'];
    }
  }
  /**
  */
  'correlationId'?: string;
  /**
  * @type {date-time}
  */
  'from'?: string;
  /**
  * @type {date-time}
  */
  'to'?: string;
  /**
  */
  'searchCriteria'?: string;
  /**
  * @type {int32}
  */
  'paging.CurrentPage'?: number;
  /**
  * @type {int32}
  */
  'paging.PageSize'?: number;
  /**
  */
  'paging.IncludeCount'?: boolean;
  /**
  */
  'paging.NoPaging'?: boolean;

  static toModel(dto: DeepPartial<GetCallLogsRequestDTO>): GetCallLogsRequestModel;
  static toModel(dto: DeepPartial<GetCallLogsRequestDTO> | undefined | null): GetCallLogsRequestModel | undefined;
  static toModel(dto: DeepPartial<GetCallLogsRequestDTO> | undefined | null): GetCallLogsRequestModel | undefined {
    return dto ? new GetCallLogsRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetCallLogsRequestModel> | GetCallLogsRequestModel) {
    const unwrapped = unwrapDataRecord(model);
    return {
      'correlationId': unwrapped.correlationId,
      'from': unwrapped.from,
      'to': unwrapped.to,
      'searchCriteria': unwrapped.searchCriteria,
      'paging.CurrentPage': unwrapped['paging.CurrentPage'],
      'paging.PageSize': unwrapped['paging.PageSize'],
      'paging.IncludeCount': unwrapped['paging.IncludeCount'],
      'paging.NoPaging': unwrapped['paging.NoPaging'],
    } as GetCallLogsRequestDTO;
  }
}
